module.exports = __webpack_public_path__ + "static/media/cq_freccia_giu b.76e48f80.svg";